module.exports = __webpack_public_path__ + "img/22_pc.8c304bd6.gif";